import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  ImageList,
  ImageListItem,
  ListSubheader,
  LinearProgress,
  Box,
  Grid,
  TextField,
  Button,
  Typography,
} from "@material-ui/core";
import api from "../../../axios";
import Api from "../../../Api";
import { useAlert } from "react-alert";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #eee",
    borderRadius: "8px"
  },
  imageList: {
    width: "100%",
    height: 300,
  },
  previewImg: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  }
}));

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default function TitlebarImageList(props) {
  const classes = useStyles();
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [filesImage, setFilesImage] = useState([]);
  const [previews, setPreviews] = useState([]);

  // Generate previews kapag nag-select ng files
  useEffect(() => {
    if (!filesImage || filesImage.length === 0) {
      setPreviews([]);
      return;
    }
    const objectUrls = Array.from(filesImage).map(file => URL.createObjectURL(file));
    setPreviews(objectUrls);

    // Cleanup memory
    return () => objectUrls.forEach(url => URL.revokeObjectURL(url));
  }, [filesImage]);

  const handleUploadClick = async (e) => {
    e.preventDefault();
    
    // Kunin ang base data (Assuming props.ItemData.data is an array)
    const baseData = props.ItemData?.data?.[0]; 
    if (!baseData) {
      alert.error("Reference data missing.");
      return;
    }

    setLoading(true);
    setProgress(0);

    const uploadPromises = Array.from(filesImage).map((file) => {
      if (file.size > 2000000) {
        alert.error(`${file.name} is too large (> 2MB)`);
        return Promise.resolve(); // Skip this file
      }

      const formData = new FormData();
      formData.append("privateSaleGroup", baseData.privateSalesGroup);
      formData.append("id", baseData.id);
      formData.append("isFeatured", 1);
      formData.append("filename", file.name);
      formData.append("files", file);

      return api.post(`${Api.request.URL}/private-sale/image/upload`, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percentCompleted);
        }
      });
    });

    try {
      await Promise.all(uploadPromises);
      alert.success("Successfully uploaded all images!");
      setFilesImage([]);
    } catch (error) {
      console.error(error);
      alert.error("Upload failed. Please try again.");
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  return (
    <Box>
      {/* SECTION 1: EXISTING IMAGES FROM SERVER */}
      <Typography variant="subtitle1" gutterBottom>Uploaded Artwork</Typography>
      <div className={classes.root}>
        <ImageList rowHeight={180} className={classes.imageList} cols={3}>
          {props.ItemData?.image?.length > 0 ? (
            props.ItemData.image.map((item, i) => (
              <ImageListItem key={i}>
                <img src={item.img_url} alt="Uploaded" className={classes.previewImg} />
              </ImageListItem>
            ))
          ) : (
            <Box p={3}><Typography color="textSecondary">No images found on server.</Typography></Box>
          )}
        </ImageList>
      </div>

      {/* SECTION 2: NEW UPLOAD PREVIEW */}
      <Box mt={4} p={2} style={{ backgroundColor: "#f6f6f6", borderRadius: "8px" }}>
        <Typography variant="subtitle2" gutterBottom>New Selection Preview</Typography>
        <div className={classes.root} style={{ minHeight: previews.length ? 150 : 50 }}>
          {previews.length > 0 ? (
            <ImageList rowHeight={150} className={classes.imageList} cols={3}>
              {previews.map((url, i) => (
                <ImageListItem key={i}>
                  <img src={url} alt="Preview" className={classes.previewImg} />
                </ImageListItem>
              ))}
            </ImageList>
          ) : (
            <Typography variant="caption" color="textSecondary" style={{ padding: 20 }}>
              Select images to see preview
            </Typography>
          )}
        </div>

        {loading && (
          <Box mt={2}>
            <LinearProgressWithLabel value={progress} />
          </Box>
        )}

        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item md={8} xs={12}>
              <TextField
                fullWidth
                type="file"
                variant="outlined"
                inputProps={{ accept: "image/jpeg, image/png", multiple: true }}
                onChange={(e) => setFilesImage(e.target.files)}
                disabled={loading}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                style={{ height: "55px" }}
                disabled={loading || !filesImage.length}
                onClick={handleUploadClick}
              >
                {loading ? "Uploading..." : "Send to Server"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}